import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';

import { usePrimeBookingAccess } from '@/features/prime-booking';

interface PrimeBookingActivityRouteProps {
  children: ReactNode;
}

/**
 * Route guard for the Prime booking activity trail.
 *
 * `/api/prime-booking/my-access/` decides who may view (individuals granted
 * `prime_booking:read` in the access console). Users without `can_view` go to /home.
 * The backend enforces the same gate on `activity/` independently.
 */
export function PrimeBookingActivityRoute({ children }: PrimeBookingActivityRouteProps) {
  const { data, isLoading, isError } = usePrimeBookingAccess();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (isError || !data?.can_view) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
